// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3OsQs","col":"styles_col__1tZ9n"};